import { AlertProps } from 'antd'

export interface IcoErrorDescription {
  errorCodeType: string
  title: string
  description: string
  message: string
  type: AlertProps['type']
}

export enum MonitoringInputType {
  CuzkRc = 'ČÚZK - RČ',
  CuzkIco = 'ČÚZK - IČ',
  CuzkName = 'ČÚZK - jméno',
  CeeRc = 'CEE - RČ',
  CeeIco = 'CEE - IČ',
  CeeName = 'CEE - jméno',
}

export enum LUSTRATION_TAB_KEYS {
  RC = 'Rodne-cislo',
  ICO = 'ICO',
  NAME = 'Jmeno',
  NAME_BULK = 'Jmeno-hromadne',
}

export const LUSTRATION_TABS = {
  [LUSTRATION_TAB_KEYS.RC]: 'Podle RČ',
  [LUSTRATION_TAB_KEYS.ICO]: 'Podle IČO',
  [LUSTRATION_TAB_KEYS.NAME]: 'Podle jména',
  [LUSTRATION_TAB_KEYS.NAME_BULK]: 'Hromadně dle jména',
}

export enum GenderType {
  M = 'Muž',
  W = 'Žena',
}
